import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.mypage');
import { normalizeMobile } from "src/libs/portal/season/contact-policy";
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-mypage',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.mypage/view.scss */
:host {
  display: block;
  min-height: 100%;
}

.market-mypage-page {
  min-height: calc(100vh - 70px);
  padding: 34px 0 72px;
  color: #12221b;
}

.market-mypage-container,
.market-mypage-state {
  width: min(1180px, 100% - 40px);
  margin: 0 auto;
}

.member-kicker {
  margin: 0;
  color: #0a7750;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.18em;
  line-height: 1.4;
}

.market-mypage-breadcrumb {
  display: flex;
  align-items: center;
  gap: 9px;
  margin-bottom: 18px;
  color: #87958e;
  font-size: 12px;
}
.market-mypage-breadcrumb a {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  color: #53665d;
  font-weight: 700;
  text-decoration: none;
}
.market-mypage-breadcrumb a:hover {
  color: #08734d;
}
.market-mypage-breadcrumb svg {
  width: 15px;
  height: 15px;
}
.market-mypage-breadcrumb strong {
  color: #243a30;
  font-weight: 700;
}

.market-profile-hero {
  position: relative;
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(460px, 0.9fr);
  gap: 42px;
  overflow: hidden;
  padding: 40px 42px;
  border: 1px solid rgba(183, 204, 192, 0.72);
  border-radius: 24px;
  background: radial-gradient(circle at 88% -15%, rgba(139, 210, 159, 0.34), transparent 38%), linear-gradient(135deg, #fbfefc 0%, #f2f8f4 58%, #edf6f0 100%);
  box-shadow: 0 24px 60px rgba(31, 71, 49, 0.1);
}
.market-profile-hero::after {
  position: absolute;
  right: 34%;
  top: -80px;
  width: 1px;
  height: 310px;
  background: linear-gradient(transparent, rgba(41, 109, 71, 0.15), transparent);
  transform: rotate(17deg);
  content: "";
}

.market-profile-identity {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  gap: 22px;
}
.market-profile-identity h1 {
  margin: 7px 0 8px;
  color: #10241a;
  font-size: clamp(25px, 2.6vw, 36px);
  font-weight: 800;
  letter-spacing: -0.045em;
  line-height: 1.18;
}
.market-profile-identity > div:last-child > p:not(.member-kicker) {
  max-width: 520px;
  margin: 0;
  color: #607169;
  font-size: 13px;
  line-height: 1.75;
}

.market-profile-avatar {
  position: relative;
  display: grid;
  flex: 0 0 auto;
  width: 92px;
  height: 92px;
  place-items: center;
  border: 1px solid rgba(255, 255, 255, 0.7);
  border-radius: 28px;
  background: linear-gradient(145deg, #123a28, #061a11);
  box-shadow: 0 18px 32px rgba(8, 50, 30, 0.22), inset 0 1px rgba(255, 255, 255, 0.16);
  color: #fff;
  font-size: 30px;
  font-weight: 800;
}
.market-profile-avatar i {
  position: absolute;
  right: -3px;
  bottom: -3px;
  width: 23px;
  height: 23px;
  border: 5px solid #f4f9f5;
  border-radius: 50%;
  background: #2bb673;
}

.market-profile-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 15px;
}
.market-profile-badges span {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  min-height: 27px;
  padding: 0 11px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 800;
}
.market-profile-badges .is-role {
  background: #dff3e7;
  color: #16633f;
}
.market-profile-badges .is-status {
  border: 1px solid #d3e3da;
  background: rgba(255, 255, 255, 0.7);
  color: #375449;
}
.market-profile-badges .is-status i {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #20a861;
  box-shadow: 0 0 0 4px rgba(32, 168, 97, 0.1);
}

.market-profile-metrics {
  position: relative;
  z-index: 1;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  align-self: stretch;
  margin: 0;
  overflow: hidden;
  border: 1px solid rgba(188, 207, 197, 0.78);
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.72);
  box-shadow: inset 0 1px rgba(255, 255, 255, 0.82);
  backdrop-filter: blur(12px);
}
.market-profile-metrics div {
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 0;
  padding: 20px;
}
.market-profile-metrics div + div {
  border-left: 1px solid #dfeae3;
}
.market-profile-metrics dt {
  color: #789087;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.06em;
}
.market-profile-metrics dd {
  overflow: hidden;
  margin: 8px 0 4px;
  color: #153427;
  font-size: 15px;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.market-profile-metrics small {
  color: #83948c;
  font-size: 10px;
  line-height: 1.45;
}

.market-profile-sync {
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  gap: 14px;
  margin-top: 18px;
  padding: 14px 16px;
  border: 1px solid #f0d7a8;
  border-radius: 14px;
  background: #fffaf0;
  color: #694917;
}
.market-profile-sync .market-profile-sync-icon {
  display: grid;
  width: 36px;
  height: 36px;
  place-items: center;
  border-radius: 11px;
  background: #fff0cc;
}
.market-profile-sync .market-profile-sync-icon svg {
  width: 19px;
  height: 19px;
}
.market-profile-sync strong {
  display: block;
  font-size: 12px;
}
.market-profile-sync p {
  margin: 3px 0 0;
  color: #886b39;
  font-size: 11px;
  line-height: 1.6;
}
.market-profile-sync button {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  height: 34px;
  padding: 0 12px;
  border: 1px solid #dfc083;
  border-radius: 9px;
  background: #fff;
  color: #73501a;
  font-size: 11px;
  font-weight: 800;
  cursor: pointer;
}
.market-profile-sync button:disabled {
  cursor: wait;
  opacity: 0.65;
}
.market-profile-sync button svg {
  width: 14px;
  height: 14px;
  animation: mypage-spin 0.8s linear infinite;
}

.market-profile-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 330px;
  gap: 22px;
  margin-top: 22px;
}

.market-profile-main,
.market-profile-aside {
  display: flex;
  flex-direction: column;
  gap: 22px;
}

.market-profile-panel,
.market-account-card,
.market-security-card,
.market-privacy-note {
  border: 1px solid #dfe8e2;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.94);
  box-shadow: 0 15px 40px rgba(28, 65, 44, 0.065);
}

.market-profile-panel {
  padding: 27px;
}

.market-profile-panel-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
}
.market-profile-panel-head h2 {
  margin: 6px 0 5px;
  color: #14271d;
  font-size: 19px;
  font-weight: 800;
  letter-spacing: -0.025em;
}
.market-profile-panel-head > div > p:not(.member-kicker) {
  margin: 0;
  color: #73847b;
  font-size: 12px;
  line-height: 1.65;
}

.market-profile-completion {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 7px;
  min-height: 30px;
  padding: 0 11px;
  border-radius: 999px;
  background: #fff4db;
  color: #936a17;
  font-size: 10px;
  font-weight: 800;
}
.market-profile-completion i {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #e7a41f;
}
.market-profile-completion.is-complete {
  background: #e5f6ec;
  color: #137044;
}
.market-profile-completion.is-complete i {
  background: #22a965;
}

.market-profile-form {
  margin-top: 24px;
}

.market-profile-fields {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 17px;
}
.market-profile-fields label > span,
.market-profile-fields .market-security-fields label > span {
  display: block;
  margin-bottom: 7px;
  color: #50665b;
  font-size: 11px;
  font-weight: 800;
}
.market-profile-fields input {
  width: 100%;
  height: 45px;
  box-sizing: border-box;
  padding: 0 13px;
  border: 1px solid #cfddd5;
  border-radius: 11px;
  outline: 0;
  background: #fff;
  color: #14271d;
  font-size: 12px;
  transition: border-color 0.18s, box-shadow 0.18s, background 0.18s;
}
.market-profile-fields input:focus {
  border-color: #26935f;
  box-shadow: 0 0 0 4px rgba(38, 147, 95, 0.1);
}
.market-profile-fields input:disabled {
  background: #f5f8f6;
  color: #7c8c84;
  cursor: not-allowed;
}
.market-profile-fields input::placeholder {
  color: #a5b1ab;
}

.market-profile-permissions {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  margin-top: 22px;
  padding-top: 22px;
  border-top: 1px solid #edf1ee;
}
.market-profile-permissions > div {
  display: flex;
  align-items: center;
  gap: 11px;
  padding: 13px;
  border-radius: 13px;
  background: #f6f9f7;
}
.market-profile-permissions > div > span {
  display: grid;
  flex: 0 0 auto;
  width: 34px;
  height: 34px;
  place-items: center;
  border: 1px solid #dce9e1;
  border-radius: 10px;
  background: #fff;
  color: #168153;
}
.market-profile-permissions svg {
  width: 17px;
  height: 17px;
}
.market-profile-permissions p {
  margin: 0;
}
.market-profile-permissions strong {
  display: block;
  color: #294237;
  font-size: 11px;
}
.market-profile-permissions small {
  display: block;
  margin-top: 3px;
  color: #829087;
  font-size: 9px;
}

.market-profile-form-action {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 14px;
  margin-top: 22px;
}
.market-profile-form-action p {
  margin: 0;
  color: #9b7a3b;
  font-size: 10px;
}
.market-profile-form-action button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-width: 132px;
  height: 42px;
  padding: 0 17px;
  border: 0;
  border-radius: 11px;
  background: linear-gradient(135deg, #0c754c, #125e41);
  box-shadow: 0 9px 20px rgba(12, 117, 76, 0.18);
  color: #fff;
  font-size: 11px;
  font-weight: 800;
  cursor: pointer;
}
.market-profile-form-action button:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 12px 24px rgba(12, 117, 76, 0.22);
}
.market-profile-form-action button:disabled {
  box-shadow: none;
  cursor: not-allowed;
  opacity: 0.5;
}
.market-profile-form-action svg {
  width: 15px;
  height: 15px;
  animation: mypage-spin 0.8s linear infinite;
}

.market-shortcut-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  margin-top: 21px;
}
.market-shortcut-grid a {
  position: relative;
  min-height: 122px;
  overflow: hidden;
  padding: 18px;
  border: 1px solid #e0e9e3;
  border-radius: 15px;
  background: #fbfdfc;
  color: inherit;
  text-decoration: none;
  transition: border-color 0.18s, box-shadow 0.18s, transform 0.18s;
}
.market-shortcut-grid a:hover {
  border-color: #9ccdb1;
  box-shadow: 0 12px 26px rgba(28, 92, 56, 0.1);
  transform: translateY(-2px);
}
.market-shortcut-grid a:hover i {
  background: #146c48;
  color: #fff;
  transform: translateX(2px);
}
.market-shortcut-grid .market-shortcut-eyebrow {
  display: block;
  color: #5b9a76;
  font-size: 8px;
  font-weight: 900;
  letter-spacing: 0.16em;
}
.market-shortcut-grid strong {
  display: block;
  margin-top: 7px;
  color: #1c3328;
  font-size: 13px;
}
.market-shortcut-grid p {
  max-width: 78%;
  margin: 7px 0 0;
  color: #7b8c83;
  font-size: 10px;
  line-height: 1.55;
}
.market-shortcut-grid i {
  position: absolute;
  right: 15px;
  bottom: 15px;
  display: grid;
  width: 29px;
  height: 29px;
  place-items: center;
  border-radius: 9px;
  background: #eaf3ed;
  color: #26724f;
  transition: 0.18s;
}
.market-shortcut-grid svg {
  width: 14px;
  height: 14px;
}

.market-account-card {
  overflow: hidden;
  padding: 22px;
  background: radial-gradient(circle at 100% 0, rgba(69, 146, 98, 0.24), transparent 42%), linear-gradient(145deg, #102e20, #081b12);
  color: #fff;
}

.market-account-card-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.market-account-card-top .member-kicker {
  color: #8dcaa7;
}
.market-account-card-top > span {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #a8c9b6;
  font-size: 8px;
  font-weight: 800;
  letter-spacing: 0.12em;
}
.market-account-card-top > span i {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #54d58a;
  box-shadow: 0 0 0 4px rgba(84, 213, 138, 0.12);
}

.market-account-person {
  padding: 26px 0 22px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.11);
  text-align: center;
}
.market-account-person > div {
  display: grid;
  width: 60px;
  height: 60px;
  margin: 0 auto 13px;
  place-items: center;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 19px;
  background: rgba(255, 255, 255, 0.09);
  color: #e8fff0;
  font-size: 20px;
  font-weight: 800;
}
.market-account-person h2 {
  margin: 0;
  font-size: 16px;
  font-weight: 800;
}
.market-account-person p {
  overflow: hidden;
  margin: 6px 0 0;
  color: #94ad9f;
  font-size: 10px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.market-account-card dl {
  display: grid;
  gap: 12px;
  margin: 18px 0 0;
}
.market-account-card dl div {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;
}
.market-account-card dl dt {
  color: #8ba498;
  font-size: 10px;
}
.market-account-card dl dd {
  overflow: hidden;
  margin: 0;
  color: #effbf3;
  font-size: 10px;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.market-account-card dl .is-active {
  color: #70dfa0;
}

.market-security-card {
  padding: 22px;
}

.market-security-head {
  display: flex;
  align-items: center;
  gap: 12px;
}
.market-security-head > span {
  display: grid;
  width: 40px;
  height: 40px;
  place-items: center;
  border-radius: 12px;
  background: #eaf5ee;
  color: #187a50;
}
.market-security-head svg {
  width: 19px;
  height: 19px;
}
.market-security-head h2 {
  margin: 4px 0 0;
  color: #1b3428;
  font-size: 15px;
  font-weight: 800;
}

.market-security-fields {
  display: grid;
  gap: 13px;
  margin-top: 20px;
}
.market-security-fields label > span {
  display: block;
  margin-bottom: 7px;
  color: #50665b;
  font-size: 10px;
  font-weight: 800;
}
.market-security-fields input {
  width: 100%;
  height: 41px;
  box-sizing: border-box;
  padding: 0 12px;
  border: 1px solid #d3dfd8;
  border-radius: 10px;
  outline: 0;
  background: #fff;
  color: #193126;
  font-size: 11px;
}
.market-security-fields input:focus {
  border-color: #26935f;
  box-shadow: 0 0 0 3px rgba(38, 147, 95, 0.09);
}
.market-security-fields input:disabled {
  background: #f5f8f6;
  cursor: not-allowed;
  opacity: 0.72;
}
.market-security-fields input::placeholder {
  color: #a6b2ac;
}

.market-security-card > button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  width: 100%;
  height: 41px;
  margin-top: 17px;
  border: 0;
  border-radius: 10px;
  background: #173b2a;
  color: #fff;
  font-size: 10px;
  font-weight: 800;
  cursor: pointer;
}
.market-security-card > button:hover:not(:disabled) {
  background: #0e2d1f;
}
.market-security-card > button:disabled {
  cursor: not-allowed;
  opacity: 0.45;
}
.market-security-card > button svg {
  width: 14px;
  height: 14px;
  animation: mypage-spin 0.8s linear infinite;
}

.market-privacy-note {
  display: flex;
  gap: 13px;
  padding: 18px;
  background: #f2f8f4;
}
.market-privacy-note > span {
  display: grid;
  flex: 0 0 auto;
  width: 35px;
  height: 35px;
  place-items: center;
  border-radius: 10px;
  background: #dff1e6;
  color: #19754d;
}
.market-privacy-note svg {
  width: 18px;
  height: 18px;
}
.market-privacy-note strong {
  color: #28463a;
  font-size: 11px;
}
.market-privacy-note p {
  margin: 4px 0 0;
  color: #75877e;
  font-size: 9px;
  line-height: 1.6;
}

.market-mypage-state {
  display: grid;
  min-height: 620px;
  place-items: center;
}

.market-mypage-state-card {
  width: min(520px, 100%);
  padding: 42px;
  border: 1px solid #dce8e1;
  border-radius: 24px;
  background: rgba(255, 255, 255, 0.92);
  box-shadow: 0 24px 60px rgba(25, 72, 45, 0.1);
  text-align: center;
}
.market-mypage-state-card h1 {
  margin: 9px 0;
  color: #152b20;
  font-size: 24px;
  font-weight: 800;
  letter-spacing: -0.035em;
}
.market-mypage-state-card > p:not(.member-kicker) {
  margin: 0;
  color: #74857c;
  font-size: 12px;
  line-height: 1.7;
}

.market-mypage-state-mark {
  display: grid;
  width: 62px;
  height: 62px;
  margin: 0 auto 18px;
  place-items: center;
  border-radius: 19px;
  background: #e6f4eb;
  color: #16774d;
}
.market-mypage-state-mark svg {
  width: 27px;
  height: 27px;
}
.market-mypage-state-mark.is-loading {
  grid-template-columns: repeat(3, 7px);
  gap: 5px;
}
.market-mypage-state-mark.is-loading span {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #168052;
  animation: mypage-pulse 1s ease-in-out infinite;
}
.market-mypage-state-mark.is-loading span:nth-child(2) {
  animation-delay: 0.15s;
}
.market-mypage-state-mark.is-loading span:nth-child(3) {
  animation-delay: 0.3s;
}
.market-mypage-state-mark.is-error {
  background: #fff0df;
  color: #b66d1e;
}

.market-mypage-skeleton {
  display: grid;
  gap: 9px;
  width: 72%;
  margin: 25px auto 0;
}
.market-mypage-skeleton span {
  height: 9px;
  border-radius: 999px;
  background: linear-gradient(90deg, #eef3f0 25%, #f9fbfa 50%, #eef3f0 75%);
  background-size: 200% 100%;
  animation: mypage-shimmer 1.4s linear infinite;
}
.market-mypage-skeleton span:nth-child(2) {
  width: 84%;
  margin: 0 auto;
}
.market-mypage-skeleton span:nth-child(3) {
  width: 62%;
  margin: 0 auto;
}

.market-mypage-state-actions {
  display: flex;
  justify-content: center;
  gap: 9px;
  margin-top: 24px;
}
.market-mypage-state-actions button,
.market-mypage-state-actions a {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 39px;
  padding: 0 15px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 800;
  text-decoration: none;
}
.market-mypage-state-actions button {
  border: 0;
  background: #126c49;
  color: #fff;
  cursor: pointer;
}
.market-mypage-state-actions a {
  border: 1px solid #d3dfd8;
  background: #fff;
  color: #3e574b;
}

@keyframes mypage-spin {
  to {
    transform: rotate(360deg);
  }
}
@keyframes mypage-pulse {
  0%, 100% {
    opacity: 0.28;
    transform: translateY(1px);
  }
  50% {
    opacity: 1;
    transform: translateY(-2px);
  }
}
@keyframes mypage-shimmer {
  to {
    background-position: -200% 0;
  }
}
@media (max-width: 1024px) {
  .market-profile-hero {
    grid-template-columns: 1fr;
    gap: 28px;
  }
  .market-profile-hero::after {
    display: none;
  }
  .market-profile-layout {
    grid-template-columns: 1fr;
  }
  .market-profile-aside {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    align-items: start;
  }
  .market-privacy-note {
    grid-column: 1/-1;
  }
}
@media (max-width: 720px) {
  .market-mypage-page {
    padding: 22px 0 48px;
  }
  .market-mypage-container,
  .market-mypage-state {
    width: min(100% - 24px, 1180px);
  }
  .market-profile-hero {
    padding: 27px 22px;
    border-radius: 19px;
  }
  .market-profile-identity {
    align-items: flex-start;
    gap: 15px;
  }
  .market-profile-avatar {
    width: 66px;
    height: 66px;
    border-radius: 20px;
    font-size: 22px;
  }
  .market-profile-avatar i {
    width: 19px;
    height: 19px;
    border-width: 4px;
  }
  .market-profile-identity h1 {
    font-size: 23px;
  }
  .market-profile-metrics {
    grid-template-columns: 1fr;
  }
  .market-profile-metrics div {
    padding: 15px 17px;
  }
  .market-profile-metrics div + div {
    border-top: 1px solid #dfeae3;
    border-left: 0;
  }
  .market-profile-sync {
    grid-template-columns: auto 1fr;
  }
  .market-profile-sync button {
    grid-column: 1/-1;
    width: 100%;
    justify-content: center;
  }
  .market-profile-panel {
    padding: 21px 18px;
  }
  .market-profile-panel-head {
    display: block;
  }
  .market-profile-completion {
    margin-top: 13px;
  }
  .market-profile-fields,
  .market-profile-permissions,
  .market-shortcut-grid,
  .market-profile-aside {
    grid-template-columns: 1fr;
  }
  .market-profile-form-action {
    align-items: stretch;
    flex-direction: column;
  }
  .market-profile-form-action button {
    width: 100%;
  }
  .market-privacy-note {
    grid-column: auto;
  }
  .market-mypage-state {
    min-height: 520px;
  }
  .market-mypage-state-card {
    padding: 34px 22px;
    border-radius: 19px;
  }
}`],
})
export class PageMypageComponent implements OnInit {
    public user: any = null;
    public loading: boolean = true;
    public loadError: string = '';
    public usingSessionProfile: boolean = false;
    public saving: boolean = false;
    public changingPassword: boolean = false;

    public tradeLinks: any[] = [
        {
            label: '판매 등록',
            eyebrow: 'SELL',
            description: '보유 IP의 판매 검수 신청을 접수합니다.',
            link: '/sell'
        },
        {
            label: '구매 등록',
            eyebrow: 'BUY',
            description: '찾는 권리 조건을 남기고 상담을 요청합니다.',
            link: '/consult'
        },
        {
            label: '자유 상담',
            eyebrow: 'CONSULT',
            description: '거래 전 문의와 중개 상담을 남깁니다.',
            link: '/qna'
        },
        {
            label: 'AI검색(구매)',
            eyebrow: 'AI SEARCH',
            description: '관심 분야의 등록권을 빠르게 탐색합니다.',
            link: '/search/ai'
        }
    ];

    public passwordForm: any = {
        current_password: '',
        new_password: '',
        confirm_password: ''
    };

    constructor(@Inject( Service) public service: Service) { }

    public get displayName() {
        if (!this.user) return '회원';
        return this.user.name || this.user.email || '회원';
    }

    public get avatarInitial() {
        const source = this.displayName || '?';
        return source.charAt(0).toUpperCase();
    }

    public get roleLabel() {
        if (!this.user) return '거래회원';
        if (this.user.role === 'admin') return '관리자';
        return '거래회원';
    }

    public get contactLabel() {
        if (!this.user || !this.user.mobile) return '미등록';
        return this.user.mobile;
    }

    public get contactStateLabel() {
        if (this.user && this.user.mobile) return '연락처 등록 완료';
        return '연락처 입력 필요';
    }

    public get memberStatusLabel() {
        return '거래 가능';
    }

    public get profileEditable() {
        return !!this.user && !this.loading && !this.usingSessionProfile;
    }

    public async ngOnInit() {
        await this.service.init();

        const allowed = this.service.auth.allow('/access');
        if (!allowed) return;

        this.seedUserFromSession();
        await this.service.render();
        await this.load();
    }

    public async load() {
        this.loading = true;
        this.loadError = '';
        await this.service.render();

        try {
            const response = await wiz.call('get');
            const code = response && response.code;
            const data = response && response.data;

            if (code === 200 && data) {
                this.user = Object.assign({}, this.user || {}, data);
                this.usingSessionProfile = false;
            } else {
                this.loadError = this.errorMessage(data, '회원 상세 정보를 불러오지 못했습니다.');
            }
        } catch (error) {
            this.loadError = '회원 정보를 불러오는 중 연결이 원활하지 않습니다.';
        }

        this.loading = false;
        await this.service.render();
    }

    public async retryLoad() {
        await this.load();
    }

    public get profileInputsValid(): boolean {
        const name = String(this.user?.name || '').trim();
        return !!name && name.length <= 50 && normalizeMobile(this.user?.mobile || '') !== null;
    }

    public async updateProfile() {
        if (this.saving) return;
        if (!this.profileEditable) {
            await this.service.modal.error('회원 정보를 다시 불러온 뒤 수정해주세요.');
            return;
        }

        this.user.name = (this.user.name || '').trim();
        this.user.mobile = (this.user.mobile || '').trim();

        if (!this.user.name) {
            await this.service.modal.error('이름을 입력해주세요.');
            return;
        }

        const mobile = normalizeMobile(this.user.mobile);
        if (this.user.name.length > 50 || mobile === null) {
            await this.service.modal.error('이름은 1~50자, 휴대전화는 010-0000-0000 형식으로 입력해 주세요.');
            return;
        }
        this.user.mobile = mobile;

        this.saving = true;
        await this.service.render();

        try {
            const { code, data } = await wiz.call('update_profile', {
                name: this.user.name,
                mobile: this.user.mobile || ''
            });

            if (code === 200) {
                await this.service.modal.success('프로필이 업데이트되었습니다.');
            } else {
                await this.service.modal.error(this.errorMessage(data, '업데이트에 실패했습니다.'));
            }
        } catch (error) {
            await this.service.modal.error('프로필 저장 중 연결이 원활하지 않습니다.');
        }

        this.saving = false;
        await this.service.render();
    }

    public async changePassword() {
        if (!this.profileEditable) {
            await this.service.modal.error('회원 정보를 다시 불러온 뒤 변경해주세요.');
            return;
        }

        const { current_password, new_password, confirm_password } = this.passwordForm;

        if (!current_password) {
            await this.service.modal.error('현재 비밀번호를 입력해주세요.');
            return;
        }
        if (!new_password) {
            await this.service.modal.error('새 비밀번호를 입력해주세요.');
            return;
        }
        if ((new_password.length < 8 || !new_password.trim() || new TextEncoder().encode(new_password).length > 72)) {
            await this.service.modal.error("비밀번호는 8자 이상, UTF-8 기준 72바이트 이내로 입력해 주세요.");
            return;
        }
        if (new_password !== confirm_password) {
            await this.service.modal.error('새 비밀번호가 일치하지 않습니다.');
            return;
        }

        this.changingPassword = true;
        await this.service.render();

        try {
            const { code, data } = await wiz.call('change_password', {
                current_password: current_password,
                new_password: new_password
            });

            if (code === 200) {
                await this.service.modal.success('비밀번호가 변경되었습니다.');
                this.passwordForm = { current_password: '', new_password: '', confirm_password: '' };
            } else {
                await this.service.modal.error(this.errorMessage(data, '비밀번호 변경에 실패했습니다.'));
            }
        } catch (error) {
            await this.service.modal.error('비밀번호 변경 중 연결이 원활하지 않습니다.');
        }

        this.changingPassword = false;
        await this.service.render();
    }

    private seedUserFromSession() {
        const auth = this.service.auth;
        const session = auth && auth.session ? auth.session : {};

        if (!session || (!session.id && !session.email && !session.name)) return;

        this.user = {
            id: session.id || '',
            email: session.email || '',
            name: session.name || session.email || '회원',
            mobile: session.mobile || '',
            role: session.role || 'user'
        };
        this.usingSessionProfile = true;
    }

    private errorMessage(data: any, fallback: string) {
        if (!data) return fallback;
        if (typeof data === 'string') return data;
        return data.message || fallback;
    }
}

export default PageMypageComponent;